import { useCallback, useEffect, useState } from "react";

import { HttpService } from "../../../services/HttpService";
import StatusPill from "../../../uiComponents/StatusPill/StatusPill";
import moment from "moment";
import Loading from "../../../components/Loading/Loading";
import ShippedDocumentsList from "./ShippedDocumentsList";
import { DocumentStatusKeys } from "../../../config/config";
import { Button } from "primereact/button";
import { useToast } from "../../../hooks/useToast";
import FilePreviewOverlay from "../../../uiComponents/FilePreviewOverlay/FilePreviewOverlay";
type Order = {
    id: number;
    uuid: string;
    status: string;
    orderNumber: string;
    shipmentDate: string;
    trackingNumber: string;
    deliveryService: string;
    deliveryAddress: {
        city: string;
        state: string;
        country: Record<string, string>;
        zipCode: string;
        addressLine1: string;
        addressLine2?: string;
    } ;
    payDateTime: string;
    returnShipmentOrderItems: Record<string, any>[];
}

function ShippedDocuments() {
    
    const { show } = useToast();
    const [orders, setOrders] = useState<Order[]>([]);
    const [isLoaded, setLoaded] = useState<boolean>(false);
    const [isDataExist, setDataExist] = useState<boolean>(false);
    const [pdfUrl, setPdfUrl] = useState('');
    const [previewLoading, setPreviewLoading] = useState(false);

    useEffect(() => {
        HttpService.get(
            "/api/return-shipment"
        ).then(res => {
            setOrders(res.data);
            setDataExist(Boolean(res.data.length))
        }).catch(erorr => {

        }).finally(() => setLoaded(true))

        return () => {
            setOrders([]);
            setLoaded(false);
            setDataExist(false);
        }
    }, []);

    const handleViewFedExProofOfDelivery = useCallback((orderNumber: string): void => {

        setPreviewLoading(true);

        HttpService.post(
            `/api/return-shipment/view/proof-of-delivered/${orderNumber}`
        ).then(res => {
            if (res.data && res.data.url) {
                setPdfUrl(res.data.url);
            }
        }).catch(error => {
            show({
                severity: 'error',
                detail: 'Error fetching FedEx proof of delivery.',
            });
        }).finally(() => {
            setPreviewLoading(false);
        });

    }, [orders]);

    return (
        <div className="w-full h-full min-h-full flex flex-column row-gap-3">
            <div className="grid -mx-3 min-h-full">
                {
                    isLoaded ? (
                        isDataExist ? (
                            orders.map((order) => {
                                return (
                                    <div key={order.id} className="p-3 col-12 sm:col-6 md:col-4">
                                        <div className="flex flex-column gap-4 p-4 p-card p-component">
                                            <div className="flex justify-content-between align-items-center">
                                                <div className="font-bold text-xl text-color">
                                                    <span className="mr-1">Shipment</span>
                                                    <span>#{order.orderNumber}</span>
                                                </div>
                                                <div className="font-semibold text-base">
                                                    <StatusPill status={order.status} />
                                                </div>
                                            </div>
                                            <div className="flex-grow-1">
                                                <div className="font-semibold text-base text-color">
                                                    <span className="mr-1">Requested Date:</span>
                                                    <span className="mr-1">{moment(order.payDateTime).format("MMM DD, YYYY")}</span>
                                                </div>
                                                <div className="font-normal text-base text-color mt-1">
                                                    <span className="mr-1">Tracking:</span>
                                                    <span>#{order.trackingNumber}</span>
                                                </div>
                                            </div>
                                        
                                            <div className="flex-grow-1">
                                                <div className="font-semibold text-base text-color">
                                                    <span className="mr-1">Shipping Address:</span>
                                                </div>
                                                    <ul className="list-none font-normal text-base text-color ml-1">
                                                        <li className="py-1">
                                                            {order.deliveryAddress.addressLine1}
                                                        </li>
                                                        {
                                                            order.deliveryAddress.addressLine2 ? (
                                                                <li className="py-1">
                                                                    {order.deliveryAddress.addressLine2}
                                                                </li>
                                                            ) : null
                                                        }
                                                        <li className="py-1">
                                                            {
                                                                (() => {
                                                                    const { city, state, zipCode } = order.deliveryAddress;
                                                                    return [city, `${state} ${zipCode}`].filter(Boolean).join(', ');
                                                                })()
                                                            }
                                                        </li>
                                                        <li className="py-1">
                                                        {order.deliveryAddress.country.name}
                                                        </li>
                                                    </ul>
                                            </div>
                                            {
                                                order.status === DocumentStatusKeys.DELIVERED ? (
                                                    <div className="flex-grow-1 my-2">
                                                        <Button outlined
                                                                severity="secondary"
                                                                icon="pi pi-file-o" 
                                                                label="FedEx Proof of Delivery"  
                                                                onClick={() => handleViewFedExProofOfDelivery(order.orderNumber)}
                                                        />
                                                        <FilePreviewOverlay
                                                            preview={pdfUrl}
                                                            isLoading={previewLoading}
                                                            closePreview={() => setPdfUrl('')}
                                                            hideDownloadButton
                                                        />
                                                    </div>
                                                ) : null
                                            }                                                
                                            <div className="flex-grow-1">
                                                <ShippedDocumentsList orders={order.returnShipmentOrderItems}/>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        ) : (
                            <div className="pt-8 w-full h-full flex justify-content-center r">
                                 <div className="flex flex-column justify-content-center align-items-center gap-3">
                                    <div className="border-circle p-4 bg-gray-100 flex-grow-1">
                                        <i className="pi pi-box text-4xl text-color"/>
                                    </div>
                                     <h3 className="text-lg font-semibold mt-2">No Shipment History</h3>
                                     <div className="text-color text-base font-normal text-center max-w-27rem">
                                        You haven't requested any physical copies yet. When you request 
                                        physical copies of your documents, the shipment orders will appear here.                                   
                                     </div>
                                </div>
                            </div>
                        )
                    ) : (
                        <div className="w-full h-full flex justify-content-center aligin-items-center">
                            <Loading horizontalSpacing={82} />
                        </div>
                    )
                }

            </div>
        </div>
    );
}

export default ShippedDocuments;